import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomerApprovalStatusLookupComponent } from './customer-approval-status-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [CustomerApprovalStatusLookupComponent],
  exports: [CustomerApprovalStatusLookupComponent]
})
export class CustomerApprovalStatusLookupModule { }
